import {OrderItem} from "~/dto/order/OrderItem";
import {DateHelper} from "~/helpers/DateHelper";

export class Order {
    id: number;
    items: Array<OrderItem> = [];
    createdAt: Date = new Date();

    static createFromObj(obj: Object): Order {
        const order = new Order(obj.id);
        order.items = obj.items.map(el => OrderItem.createFromObj(el));

        const date = new Date();
        date.setTime(obj.createdAt * 1000);
        order.createdAt = date;

        return order;
    }

    get title() {
        const date = DateHelper.formatDate(this.createdAt);
        return `Заказ №${this.id} - ${date}`;
    }

    constructor(id: number) {
        this.id = id;
    }

}